import { render, staticRenderFns } from "./alt-alert.vue?vue&type=template&id=22cfb5d2&"
import script from "./alt-alert.vue?vue&type=script&lang=ts&"
export * from "./alt-alert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports